const domaine = 'DISPONIBILITE_AVOIRS'

export const AJOUTER_DISPONIBILITE_AVOIRS = `${domaine}/AJOUTER_DISPONIBILITE_AVOIRS`
